import React from 'react';
import { TriangleAlert, PackageCheck } from 'lucide-react';
import { ProductCard, findProductByValue, StatusTag, EmptyState, CollapsibleCard } from '../../../common';

function EmergencyInventory({ inventory }) {
    const emergencyProds = inventory?.filter((i) => i.isEmergency) || [];
    const prods = emergencyProds?.map((fp) => findProductByValue(fp?.productId)).filter(Boolean);

    return (
        <CollapsibleCard
            title="Productos en Emergencia"
            icon={<TriangleAlert />}
            iconTone="warning"
            badges={prods.length > 0 && <StatusTag tone="warning">{prods.length} productos</StatusTag>}>
            {prods.length === 0 ? (
                <EmptyState icon={<PackageCheck />} title="Sin emergencias" description="No hay productos en emergencia" />
            ) : (
                <div>
                    <p className="m-0 mb-4 text-xs text-surface-500">Productos con bajo inventario que requieren reabastecimiento</p>
                    <div className="flex flex-row w-full flex-wrap gap-4">
                        {prods?.map((product, i) => (
                            <ProductCard product={product} key={i} />
                        ))}
                    </div>
                </div>
            )}
        </CollapsibleCard>
    );
}

export default EmergencyInventory;
